module.exports = __webpack_public_path__ + "img/tarj-4.fd9c60b4.svg";